// @flow
'use strict';

import { connect } from 'react-redux';

import BotaoOpcaoCienciaOperacao from './botao_opcao_ciencia_operacao';

export default connect<*, *, *, *, *, *>()(BotaoOpcaoCienciaOperacao);
